import { render, staticRenderFns } from "./PendingIncomeFromSale.vue?vue&type=template&id=ada0f39e&scoped=true&"
import script from "./PendingIncomeFromSale.vue?vue&type=script&lang=js&"
export * from "./PendingIncomeFromSale.vue?vue&type=script&lang=js&"
import style0 from "./PendingIncomeFromSale.vue?vue&type=style&index=0&id=ada0f39e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0f39e",
  null
  
)

export default component.exports